var actions = {"button":"_button_r522l_1 _base-button_psxg9_3 _focus_wv584_1","icon-button":"_icon-button_r522l_1 _base-button_psxg9_3 _focus_wv584_1","iconButton":"_icon-button_r522l_1 _base-button_psxg9_3 _focus_wv584_1"};

export { actions as default };
